// Estado "código pronto", de mockups/1e-celular-codigo.html: o pairingCode de 6 dígitos
// grande (dividido 3–3) na moldura "blueprint", para o médico digitar no editor desktop.
//
// Desvios conscientes do texto do mockup (marcados no relatório), por HONESTIDADE de
// estado — o celular só conhece o código, nada mais:
//   - "ÁUDIO JÁ APAGADO" -> "ÁUDIO APAGADO APÓS A TRANSCRIÇÃO": no instante em que o
//     código aparece o worker ainda está processando; o expurgo (regra 6) acontece
//     logo depois, no servidor. Afirmar "já apagado" aqui seria falso.
//   - Removido "4 TRECHOS INCERTOS": a contagem só existe depois da estruturação; o
//     celular não a conhece (é dado do editor).
//   - Removido o contador "expira em 14:38": a validade (15 min) conta a partir de
//     "pronto" no servidor, momento que o celular não conhece — um contador aqui
//     mostraria número inventado.

import type { CSSProperties } from 'react';

import { corC, fonteC, btnPrimarioC, btnSecundarioC } from '../../styles/tokensCelular';

interface Props {
  codigo: string;
  onNovo: () => void;
  onGerarOutro: () => void;
}

function Corner({ pos }: { pos: 'tl' | 'tr' | 'bl' | 'br' }): JSX.Element {
  const v: Record<string, CSSProperties> = {
    tl: { top: -6, left: -6 },
    tr: { top: -6, right: -6 },
    bl: { bottom: -6, left: -6 },
    br: { bottom: -6, right: -6 },
  };
  return (
    <span style={{ position: 'absolute', width: 11, height: 11, color: corC.blueprintCorner, ...v[pos] }}>
      <span style={{ position: 'absolute', left: 5, top: 0, width: 1, height: '100%', background: 'currentColor' }} />
      <span style={{ position: 'absolute', top: 5, left: 0, width: '100%', height: 1, background: 'currentColor' }} />
    </span>
  );
}

export function CodigoPronto({ codigo, onNovo, onGerarOutro }: Props): JSX.Element {
  const a = codigo.slice(0, 3);
  const b = codigo.slice(3, 6);
  const grupo: CSSProperties = {
    fontFamily: fonteC.mono,
    fontSize: 56,
    lineHeight: 1,
    letterSpacing: '.06em',
    color: corC.texto,
  };

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '24px 20px 0' }}>
        <span
          style={{
            fontFamily: fonteC.condensada,
            fontWeight: 600,
            fontSize: 17,
            letterSpacing: '.18em',
            color: corC.texto,
          }}
        >
          NOTA PRONTA
        </span>
        <div style={{ height: 1, flex: 1, background: corC.divisor }} />
      </div>

      <div style={{ padding: '34px 20px 0' }}>
        <div
          style={{
            fontFamily: fonteC.mono,
            fontSize: 10,
            letterSpacing: '.16em',
            color: corC.muted,
            marginBottom: 14,
          }}
        >
          DIGITE ESTE CÓDIGO NO COMPUTADOR
        </div>
        <div
          style={{
            position: 'relative',
            border: `1px solid ${corC.blueprint}`,
            padding: '26px 10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 16,
          }}
        >
          <Corner pos="tl" />
          <Corner pos="tr" />
          <Corner pos="bl" />
          <Corner pos="br" />
          <span style={grupo}>{a}</span>
          <span style={{ width: 16, height: 2, background: corC.separador, display: 'block' }} />
          <span style={grupo}>{b}</span>
        </div>
        <div
          style={{
            marginTop: 14,
            fontFamily: fonteC.mono,
            fontSize: 11.5,
            color: corC.muted,
            letterSpacing: '.06em',
          }}
        >
          vmed.app
        </div>
      </div>

      <div style={{ padding: '26px 20px 0', fontSize: 13.5, lineHeight: 1.55, color: corC.muted }}>
        Abra <b style={{ color: corC.texto }}>vmed.app</b> no terminal da UBS e digite os seis dígitos.
        Não há login.
      </div>

      <div style={{ marginTop: 'auto', padding: '0 20px 20px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div
          style={{
            borderTop: `1px solid ${corC.divisorFraco}`,
            paddingTop: 14,
            fontFamily: fonteC.mono,
            fontSize: 10,
            letterSpacing: '.12em',
            color: corC.muted,
          }}
        >
          ÁUDIO APAGADO APÓS A TRANSCRIÇÃO
        </div>
        <button type="button" onClick={onNovo} style={{ ...btnPrimarioC, height: 56, fontSize: 19 }}>
          NOVO ATENDIMENTO
        </button>
        <button
          type="button"
          onClick={onGerarOutro}
          style={{ ...btnSecundarioC, height: 48, fontSize: 16, letterSpacing: '.08em' }}
        >
          GERAR OUTRO CÓDIGO
        </button>
      </div>
    </div>
  );
}
